import React from 'react';
import Animate from 'react-move/Animate';

import { numberFormat, quadOut } from '../../helper/utils';

import './medianMarker.styl';

const MedianMarker = props => (
  <Animate
    start={{ y: props.y }}
    enter={{ y: props.y }}
    update={{
      y: [props.y],
      timing: { duration: 300, quadOut }
    }}
  >
    {state => (
      <g className="median-marker">
        <text
          className="median-marker__label"
          x="0"
          y={state.y}
          dy={-2.75}
          dx={props.dx}
          textAnchor={props.textAnchor}
        >{props.keyLabel}
        </text>
        <line
          className="median-marker__line"
          x1="0"
          y1={state.y}
          x2={props.width}
          y2={state.y}
        />
        <text
          className="median-marker__label"
          x="0"
          y={state.y}
          dy={11}
          dx={props.dx}
          textAnchor={props.textAnchor}
        > {`${numberFormat(+props.label, props.currentLanguage)} Euro`}
        </text>
      </g>
    )}
  </Animate>
);

export default MedianMarker;



// WEBPACK FOOTER //
// ./src/components/MedianMarker/index.js